import React, { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";
export const Card = ({ item }) => {
  return (
    <div className="item-card">
      <div className="item-card-content">
        <div className="item-card-title">{item.title}</div>
        <div className="item-card-description1">{item.description1}</div>
        <div className="item-card-subtitle">{item.subtitle}</div>
        <div className="item-card-description2">{item.description2}</div>
      </div>
      <div className="item-card-img">
        <img src={item.img} alt="authing" />
      </div>
    </div>
  );
};

export const TenantCustomer = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    // eslint-disable-next-line no-undef
    new Swiper(".swiper-container", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      effect: "coverflow",
      slidesPerView: 2,
      spaceBetween: "-80%",
      loop: true,
      centeredSlides: true,
      coverflowEffect: {
        rotate: 0,
        modifier: 3,
        slideShadows: false,
        stretch: -300,
        depth: 1050,
      },
    });
  }, []);
  const productLists = useMemo(() => {
    return [
      {
        title: t("tenant.customer.item1.title1"),
        img: "//files.authing.co/authing-website/tenant-customer-3.png",
        description1: t("tenant.customer.item1.descript1"),
        subtitle: t("tenant.customer.item1.title2"),
        description2: t("tenant.customer.item1.descript2"),
      },
      {
        title: t("tenant.customer.item2.title1"),
        img: "//files.authing.co/authing-website/tenant-customer-1.png",
        description1: t("tenant.customer.item2.descript1"),
        subtitle: t("tenant.customer.item2.title2"),
        description2: t("tenant.customer.item2.descript2"),
      },
      {
        title: t("tenant.customer.item3.title1"),
        img: "//files.authing.co/authing-website/tenant-customer-2.png",
        description1: t("tenant.customer.item3.descript1"),
        subtitle: t("tenant.customer.item3.title2"),
        description2: t("tenant.customer.item3.descript2"),
      },
    ];
  }, [t]);
  return (
    <div>
      <section className="tenant-customer">
        <div className="inner">
          <div className="title">{t("tenant.customer.title")}</div>
          <div className="swiper">
            <div className="swiper-container">
              <div class="swiper-wrapper">
                {productLists.map((item, index) => {
                  return (
                    <div class="swiper-slide" key={`item-${index}`}>
                      <Card item={item} />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="arrow-icon-outer-prev swiper-button-prev">
              <div className="arrow-icon-outer">
                <div className="arrow-icon-inner">
                  <i className="icon authing-icon authing-arrow-left-s-line"></i>
                </div>
              </div>
            </div>
            <div className="arrow-icon-outer-next swiper-button-next">
              <div className="arrow-icon-outer">
                <div className="arrow-icon-inner">
                  <i className="icon authing-icon authing-arrow-right-s-line"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
